export default __webpack_public_path__ + "static/media/cafe_4.8eecb5b8.jpg";